var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-timeline',{attrs:{"items":_vm.timelineEntries,"color":_vm.color},scopedSlots:_vm._u([{key:"default",fn:function(entry){return [_c('EvenementCard',{attrs:{"evenement":entry.item},on:{"menuClick":_vm.onMenuClick}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }